export enum FormAction {
  EDITING = 'editing',
  CREATING = 'creating',
}
